import { createContext, useContext } from 'react';

/**
 * True for the focused tab pane. Future split-view support may make more than
 * one tab visible, so callers should use this for "active/focused" behavior only.
 */
const TabActiveContext = createContext(true);
const CurrentTabIdContext = createContext<UUID | null>(null);

export const TabActiveProvider = TabActiveContext.Provider;
export const CurrentTabIdProvider = CurrentTabIdContext.Provider;

export function useIsTabActive(): boolean {
  return useContext(TabActiveContext);
}

export function useCurrentTabId(): UUID | null {
  return useContext(CurrentTabIdContext);
}

export function useCurrentTabIdOrThrow(): UUID {
  const tabId = useCurrentTabId();
  if (!tabId) throw new Error('useCurrentTabIdOrThrow must be used within a tab pane.');
  return tabId;
}
